import { CloseOutlined, FilterOutlined } from '@ant-design/icons';
import { Card, Col, Drawer, Grid, Row, Spin, Table } from 'antd';
import * as Api from 'api';
import ChartBesttimeLine from 'components/activity/chartBesttimeLine';
import ChartSummaryBar from 'components/activity/chartSummaryBar';
import ChartWindDirection from 'components/activity/chartWindDirection';
import FilterTargetProfile from 'components/activity/filterTargetProfile';
import { useEffect, useState } from 'react';
import useApi from 'redux/api/api.hook';
import useAuth from 'redux/auth/auth.hook';
import * as Res from 'res';
import classes from './style.module.scss';

const { useBreakpoint } = Grid;
const LABELS_TEMP = ['0F', '10F', '20F', '30F', '40F', '50F', '60F', '70F', '80F', '90F', '100F+'];
const LABELS_WIND_SPEED = ['0MPH', '3MPH', '6MPH', '9MPH', '12MPH', '15MPH', '18MPH', '21MPH+'];
const LABELS_WIND_DIR = ['N', 'NNE', 'NE', 'ENE', 'E', 'ESE', 'SE', 'SSE', 'S', 'SSW', 'SW', 'WSW', 'W', 'WNW', 'NW', 'NNW'];

const TargetProfilePage = () => {
  const { showLeftFilter, setShowLeftFilter } = useApi();
  const { md, xs } = useBreakpoint();
  const [loadingSummary, setLoadingSummary] = useState(false);
  const [loadingCommonTime, setLoadingCommonTime] = useState(false);
  const [loadingWeatherT, setLoadingWeatherT] = useState(false);
  const [loadingWeatherWD, setLoadingWeatherWD] = useState(false);
  const [loadingWeatherWS, setLoadingWeatherWS] = useState(false);

  const { auth: { profile } } = useAuth();

  const [weatherTemp, setWeatherTemp] = useState<any[]>([]);
  const [weatherWindDir, setWeatherWindDir] = useState<any[]>([]);
  const [weatherWindSpeed, setWeatherWindSpeed] = useState<any[]>([]);
  const [cameras, setCameras] = useState<any[]>([]);
  const [dataNumber, setDataNumber] = useState<any[]>([]);
  const [dataCamera, setDataCamera] = useState<any>({
    Deer: 0,
    Hog: 0,
    Turkey: 0,
    People: 0,
    Vehicle: 0,
    Predator: 0,
    Other: 0,
  });
  const [filters, setFilters] = useState<any>(null);

  const commonTimeColumns = [
    {
      title: 'Camera',
      dataIndex: 'camera_name',
      key: 'camera_name',
    },
    {
      title: 'Time',
      dataIndex: 'time',
      key: 'time',
    },
  ];
  const [commonTimeData, setCommonTimeData] = useState([]);
  const [summary, setSummary] = useState('');

  useEffect(() => {
    if (filters) {
      setLoadingSummary(true);
      const camerasFilter = filters.camera_id == 0 ? [] : [filters.camera_id];
      const tagFilter: any[] = [];
      if (filters.tag != '') {
        tagFilter.push(filters.tag);
      }

      const categoryFilter: any[] = [];
      if (filters.category != 'all') {
        categoryFilter.push(filters.category);
      }

      const param = {
        is_minute: filters.count_type,
        cameras: camerasFilter,
        tags: tagFilter,
        categories: categoryFilter,
        fromDate: '',
        toDate: '',
        type: '',
      };

      Api.CHART_SUMMARY(param).then(((res: any) => {
        const result = JSON.parse(res.text);
        setLoadingSummary(false);
        setCameras(result.cameraNames);
        setDataCamera({
          Deer: result.total.Deer,
          Hog: result.total.Hog,
          Turkey: result.total.Turkey,
          People: result.total.People,
          Vehicle: result.total.Vehicle,
          Predator: result.total.Predator,
          Other: result.total.Other,
        });

        const data: any = [];
        Object.keys(result.number).forEach((key) => {
          const name = result.cameraNames[key] || '';
          if (name == '') { return; }
          console.log(name);
          let count = 0;
          let totalCount = 0;
          for (const [, value] of Object.entries(result.number[key])) {
            totalCount += Number(value);
          }
          console.log(totalCount);
          if (filters.category == 'deer') {
            count = result.number[key].Deer || 0;
          } else if (filters.category == 'hog') {
            count = result.number[key].Hog || 0;
          } else if (filters.category == 'turkey') {
            count = result.number[key].Turkey || 0;
          } else if (filters.category == 'people') {
            count = result.number[key].People || 0;
          } else if (filters.category == 'vehicle') {
            count = result.number[key].Vehicle || 0;
          } else if (filters.category == 'predator') {
            count = result.number[key].Predator || 0;
          } else if (filters.category == 'other') {
            count = result.number[key].Other || 0;
          } else if (filters.category == 'all') {
            count = totalCount;
          }
          data.push({ name, count });
        });
        setDataNumber(data.sort((a, b) => b.count - a.count).slice(0, 3));
      })).catch((error: any) => {
        console.log('error ===>', error);
        setLoadingSummary(false);
      });

      setLoadingCommonTime(true);
      Api.TARGET_PROFILE_COMMON_TIME(param).then(((res: any) => {
        const result = JSON.parse(res.text);
        setCommonTimeData(result.result);
        setLoadingCommonTime(false);
      })).catch((error: any) => {
        console.log('error ===>', error);
        setLoadingCommonTime(false);
      });

      Api.TARGET_PROFILE_SUMMARY().then(((res: any) => {
        const result = JSON.parse(res.text);
        console.log('result', result.summary);
        setSummary(result.summary);
      })).catch((error: any) => {
        console.log('error ===>', error);
      });

      param.type = 'temp';
      setLoadingWeatherT(true);
      Api.CHART_WEATHER(param).then(((res: any) => {
        const result = JSON.parse(res.text);
        setWeatherTemp(result);
        setLoadingWeatherT(false);
      })).catch((error: any) => {
        console.log('error ===>', error);
        setLoadingWeatherT(false);
      });

      param.type = 'wind_dir';
      setLoadingWeatherWD(true);
      Api.CHART_WEATHER(param).then(((res: any) => {
        const result = JSON.parse(res.text);
        setWeatherWindDir(result);
        setLoadingWeatherWD(false);
      })).catch((error: any) => {
        console.log('error ===>', error);
        setLoadingWeatherWD(false);
      });

      param.type = 'wind_speed';
      setLoadingWeatherWS(true);
      Api.CHART_WEATHER(param).then(((res: any) => {
        const result = JSON.parse(res.text);
        setWeatherWindSpeed(result);
        setLoadingWeatherWS(false);
      })).catch((error: any) => {
        console.log('error ===>', error);
        setLoadingWeatherWS(false);
      });
    }
  }, [filters]);

  const handleFilters = (arg) => {
    setFilters(arg);
  };

  const handleRightFilter = (willShow) => {
    setShowLeftFilter(willShow);
  };

  const capitalizeFirstLetter = (string) => {
    if (string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
    return '';
  };

  return (
    <>
      <Row>
        {md && (
          <Col md={8} lg={6} xxl={4}>
            <div className={classes.imageFilter}>
              <FilterTargetProfile
                handleFilters={(arg) => handleFilters(arg)}
              />
            </div>
          </Col>
        )}
        {md == false && (
          <Drawer
            title="Filter"
            width={300}
            onClose={() => handleRightFilter(false)}
            visible={showLeftFilter}
            zIndex={900}
            handler={
              (
                <div className={classes.drawerHandle}>
                  {
                    showLeftFilter ? <CloseOutlined onClick={() => handleRightFilter(false)} /> : <FilterOutlined onClick={() => handleRightFilter(true)} />
                  }
                </div>
              )
            }
          >
            <FilterTargetProfile
              handleFilters={(arg) => handleFilters(arg)}
            />
          </Drawer>
        )}
        <Col md={16} xs={24} lg={18} xxl={20}>
          <div className={classes.content} style={{ padding: md ? 16 : 0 }}>
            {filters && (
              <Row>
                <Col xs={24}>
                  <Card title="Activity Summary" className={classes.activityCard} headStyle={{ backgroundColor: '' }}>
                    {summary}
                  </Card>
                </Col>
                <Col md={12} xs={24} style={{ paddingRight: md ? 8 : 0 }}>
                  <Col xs={24}>
                    <Card title="Most Common Time" className={classes.activityCard} headStyle={{ backgroundColor: '' }}>
                      <Spin spinning={loadingCommonTime} size="large">
                        <Table columns={commonTimeColumns} dataSource={commonTimeData} pagination={{ pageSize: 5 }} />
                      </Spin>
                    </Card>
                  </Col>
                  <Col xs={24}>
                    <Card title="Most Common Cameras" className={classes.activityCard} headStyle={{ backgroundColor: '' }}>
                      <Spin spinning={loadingSummary} size="large">
                        <ChartSummaryBar data={dataNumber} cameras={cameras} color={Res.categoryColors[capitalizeFirstLetter(filters.category)]} color_alpha={Res.categoryColorsAlpha[capitalizeFirstLetter(filters.category)]} />
                      </Spin>
                    </Card>
                  </Col>
                </Col>
                <Col md={12} xs={24} style={{ paddingLeft: md ? 8 : 0 }}>
                  <Row>
                    <Col xs={24}>
                      <Card title="Temperature Activity" className={classes.activityCard}>
                        <Spin spinning={loadingWeatherT} size="large">
                          <ChartBesttimeLine data={weatherTemp} color={Res.categoryColors[capitalizeFirstLetter(filters.category)]} color_alpha={Res.categoryColorsAlpha[capitalizeFirstLetter(filters.category)]} label="Temperature" labels={LABELS_TEMP} />
                        </Spin>
                      </Card>
                    </Col>
                    <Col xs={24}>
                      <Card title="Wind Direction Activity" className={classes.activityCard}>
                        <Spin spinning={loadingWeatherWD} size="large">
                          <ChartWindDirection data={weatherWindDir} color={Res.categoryColors[capitalizeFirstLetter(filters.category)]} color_alpha={Res.categoryColorsAlpha[capitalizeFirstLetter(filters.category)]} label="Wind Direction" labels={LABELS_WIND_DIR} />
                        </Spin>
                      </Card>
                    </Col>
                    <Col xs={24}>
                      <Card title="Wind Speed Activity" className={classes.activityCard}>
                        <Spin spinning={loadingWeatherWS} size="large">
                          <ChartBesttimeLine data={weatherWindSpeed} color={Res.categoryColors[capitalizeFirstLetter(filters.category)]} color_alpha={Res.categoryColorsAlpha[capitalizeFirstLetter(filters.category)]} label="Wind Speed" labels={LABELS_WIND_SPEED} />
                        </Spin>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            )}
          </div>
        </Col>
      </Row>
    </>
  );
};

export default TargetProfilePage;
